import type { LocationPermissionResponse } from 'expo-location';
import type { NotificationPermissionsStatus } from 'expo-notifications';

import type { MachineContext } from 'xstate5';
import type { GuardArgs } from 'xstate5/dist/declarations/src/guards';

// ─── Actors ──────────────────────────────────────────────────────────────────

export type PushNotificationPermissionStatus = NotificationPermissionsStatus;
export type RequestPushNotificationPermissionOutput = NotificationPermissionsStatus;

export type LocationPermissionStatus = LocationPermissionResponse;
export type RequestLocationPermissionOutput = LocationPermissionResponse;

// ─── Events ──────────────────────────────────────────────────────────────────

export type Event =
  | { type: 'REQUEST_PUSH_NOTIFICATION_PERMISSIONS' }
  | { type: 'SKIP_PUSH_NOTIFICATION_PERMISSIONS' }
  | { type: 'REQUEST_LOCATION_PERMISSIONS' }
  | { type: 'SKIP_LOCATION_PERMISSIONS' };

// ─── Guards ──────────────────────────────────────────────────────────────────

export type Guard<Params = void> = (
  args: GuardArgs<MachineContext, Event>,
  params: Params,
) => boolean;
